import { createAsyncThunk } from '@reduxjs/toolkit';

export const createPage = createAsyncThunk(
  'page/create',
  async ({ accountId, siteId, pageData }, { rejectWithValue }) => {
    try {
      const response = await fetch(`/api/accounts/${accountId}/microsites/${siteId}/pages`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(pageData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to create page');
      }

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchMicroSitePages = createAsyncThunk(
  'page/fetchAll',
  async ({ accountId, siteId }, { rejectWithValue }) => {
    try {
      const response = await fetch(`/api/accounts/${accountId}/microsites/${siteId}/pages`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to fetch pages');
      }

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updatePage = createAsyncThunk(
  'page/update',
  async ({ accountId, siteId, pageId, pageData }, { rejectWithValue }) => {
    try {
      const response = await fetch(`/api/accounts/${accountId}/microsites/${siteId}/pages/${pageId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(pageData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to update page');
      }

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletePage = createAsyncThunk(
  'page/delete',
  async ({ accountId, siteId, pageId }, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `/api/accounts/${accountId}/microsites/${siteId}/pages/${pageId}`,
        {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to delete page');
      }

      return pageId; // Return the ID of the deleted page
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
); 